import { render, staticRenderFns } from "./DialogLayout.vue?vue&type=template&id=0a62cc22&scoped=true&"
var script = {}
import style0 from "./DialogLayout.vue?vue&type=style&index=0&id=0a62cc22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a62cc22",
  null
  
)

component.options.__file = "DialogLayout.vue"
export default component.exports